import React from 'react';
import { View } from 'react-native';

import NextULogo from '../../atoms/logos/next-u-logo';
import OpenEnglishJuniorLogo from '../../atoms/logos/open-english-junior-logo';
import OpenEnglishLogo from '../../atoms/logos/open-english-logo';
import OpenMundoLogo from '../../atoms/logos/open-mundo-logo';
import { flex } from '../../style-utils';

const LogosRow = () => {
  return (
    <View style={[flex('flex-row', 'justify-content-between')]}>
      <OpenEnglishLogo width={81} height={31} viewBox="0 0 120 46" />
      <NextULogo />
      <OpenEnglishJuniorLogo />
      <OpenMundoLogo />
    </View>
  );
};

export default LogosRow;
